import React from "react";
import { Separator } from "_common/ui/components/Separator";
import { CollapseSection } from "_common/ui/components/CollapseSection";
import { Container } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

interface Props {
    homeTitleStyle?: boolean;
}

export default function PropertyFaq({ homeTitleStyle }: Props) {
    const { t } = useTranslation();

    const formatAnswer = (answer: string) => {
        return answer.split("\n").map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    return (
        <Container
            className={clsx("w-full lg:max-w-[690px] !px-0", {
                " min-h-[400px]": !homeTitleStyle,
            })}
        >
            <h2
                className={clsx("", {
                    "headerHome colorPrimary": homeTitleStyle,
                    "text-lg text-[var(--color-primary)] mb-4 pl-3": !homeTitleStyle,
                })}
                dangerouslySetInnerHTML={{ __html: t("propertiesPage.faq.title") }}
            />
            <div
                className={clsx("mx-auto mt-4", {
                    "pl-3": !homeTitleStyle,
                })}
            >
                <CollapseSection
                    title={t("property.faq.first.question")}
                    heightOfCollapsable={0}
                    titleClassName={"font-normal"}
                    className={"pl-0 pr-0"}
                >
                    <div className={"text-base py-3"}>{formatAnswer(t("property.faq.first.answer"))}</div>
                </CollapseSection>
                <Separator className={"py-1"} />
                <CollapseSection
                    title={t("property.faq.second.question")}
                    heightOfCollapsable={0}
                    titleClassName={"font-normal"}
                    className={"pl-0 pr-0"}
                >
                    <div className={"text-base py-3"}>{formatAnswer(t("property.faq.second.answer"))}</div>
                </CollapseSection>
                <Separator className={"py-1"} />
                <CollapseSection
                    title={t("property.faq.third.question")}
                    heightOfCollapsable={0}
                    titleClassName={"font-normal"}
                    className={"pl-0 pr-0"}
                >
                    <div className={"text-base py-3"}>{formatAnswer(t("property.faq.third.answer"))}</div>
                </CollapseSection>
                <Separator className={"py-1"} />
                <CollapseSection
                    title={t("property.faq.fourth.question")}
                    heightOfCollapsable={0}
                    titleClassName={"font-normal"}
                    className={"pl-0 pr-0"}
                >
                    <div className={"text-base py-3"}>{formatAnswer(t("property.faq.fourth.answer"))}</div>
                </CollapseSection>
            </div>
        </Container>
    );
}
